module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2zm22 23a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-3c0-1.106-.894-2-2-2H4V4h24v16h-4c-1.106 0-2 .894-2 2v3z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/inbox-1.js
// module id = 1183
// module chunks = 14